// Libs
import Vue from 'vue'
import Router from 'vue-router'
// Main Components
import Home from '@/components/Home'
import TrainingList from '@/components/TrainingList'
import CreateProfile from '@/components/CreateProfile'
// Settings Components
import EatingPlan from '@/components/Settings/EatingPlan'
import Profile from '@/components/Settings/Profile'
import PaymentConfirm from '@/components/Settings/PaymentConfirm'
import ReciptFind from '@/components/Settings/ReciptFind'
import Statisitc from '@/components/Settings/Statisitc'
import Training from '@/components/Settings/TrainingMen'
import TrainingEmpty from '@/components/Settings/TrainingEmpty'
import TrainingFlow from '@/components/Settings/TrainingFlow'
import TrainingEnd from '@/components/Settings/TrainingEnd'
// Pages
import PaymentError from '@/components/Pages/PaymentError'
// LangKyfuage Specific
import Help from '@/components/LangKyf/IE/Help'
import Imprint from '@/components/LangKyf/IE/Imprint'
import Terms from '@/components/LangKyf/IE/Terms'
import LP from '@/components/LangKyf/IE/LP'



Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/create-profile',
            name: 'CreateProfile',
            component: CreateProfile
        },
        {
            path: '/help',
            name: 'Help',
            component: Help
        },
        {
            path: '/imprint',
            name: 'Imprint',
            component: Imprint
        },
        {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/eating-plan',
            name: 'EatingPlan',
            component: EatingPlan
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/recipt-find',
            name: 'ReciptFind',
            component: ReciptFind
        },
        {
            path: '/lp',
            name: 'LP',
            component: LP
        },
        {
            path: '/statisitc',
            name: 'Statisitc',
            component: Statisitc
        },
        {
            path: '/training',
            name: 'Training',
            component: Training
        },
        {
            path: '/training2',
            name: 'TrainingEmpty',
            component: TrainingEmpty
        },
        {
            path: '/training-program',
            name: 'TrainingFlow',
            component: TrainingFlow
        },
        {
            path: '/training-end',
            name: 'TrainingEnd',
            component: TrainingEnd
        },
        {
            path: '/payment-confirmation',
            name: 'PaymentConfirm',
            component: PaymentConfirm
        },
        {
            path: '/payment-error',
            name: 'PaymentError',
            component: PaymentError
        },
        {
            path: '/training-list',
            name: 'TrainingList',
            component: TrainingList
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/kyf/ie.js